import React from 'react'
// import selexbg from '../../images/selexmbbg.png"'
import selexbg from "../../images/selexmbbg2.png";
import { Box } from "@mui/system";




const BackgroundContainer = (props) => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${selexbg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        // border:"10px solid black",
        height:"100%",
        minHeight:"100%",
        // border:"10px solid black",
        overflow:"hidden",
        // background
        // backgroundColor:"red",
        // height: "1050px",
        // display:"flex",
        /* Full height */
        /* Center and scale the image nicely */
        // background-position: center;
        // background-repeat: no-repeat;
        // background-size: cover;

        "@media (max-width: 768px)": {
          backgroundColor:"#0078C9",
          backgroundSize: "contain",

          
        },
      }}
    > 
    {props.children}
    </Box>
  )
}

export default BackgroundContainer